import React, { useState, useEffect, useRef, useContext } from "react";
import axios from "axios";
import './../../Style/InsertRent.scss'
import { errorAlert, updateAlert } from "../../Components/Alerts";
import { ApiLink } from "../../APILink/ApiLink";
import authHeader from "../../Auth/authHeader";
import jwtDecode from "jwt-decode";
import { Paper, TextareaAutosize } from "@mui/material";
import "jspdf-autotable";
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import './../../Style/TableStyle.scss'
import { MdEdit } from "react-icons/md";
import InsertTenants from "../Tenants/InsertTenants";
import Autocomplete from "@mui/material/Autocomplete";
import { FiscalYearContext } from "../../FiscalYear/FiscalYearContext";
import { TitleElements } from "../../Components/HeadersCRUD-s";
import { LinkAndClickButton } from "../../Components/AddElementsButton";
import { HeaderPaperComponent } from "../../Components/HeaderPaperComponent";
import CancelModal from "../../Components/CancelModal";

export default function EditOfficialRent({ item, onClose }) {
    const TranscationData = [
        {
            id: 1,
            type: "Vendor"
        },
        {
            id: 2,
            type: "Ndërkombëtar"
        },
    ]
    // const vitAktual = new Date().getFullYear();
    const { fiscalYear } = useContext(FiscalYearContext);
    const [showModal, setShowModal] = useState(false);
    const [changeButton, setChangeButton] = useState(false)

    const [minDate, setMinDate] = useState('');
    const [maxDate, setMaxDate] = useState('');

    const [netoRent, setNetoRent] = useState(item.QirajaNeto);
    const [vat9, setVat9] = useState(item.TatimiNeQira);
    const [payValue, setPayValue] = useState(item.PerPagese);
    const [vat, setVAt] = useState(item.TVSH);

    useEffect(() => {
        setMinDate(`${fiscalYear}-01-01`);
        setMaxDate(`${fiscalYear}-12-31`);
    }, [fiscalYear])
    const headers = authHeader();

    const [logedEmail, setLogedEmail] = useState("");

    useEffect(() => {
        const token = localStorage.getItem("token");
        if (token) {
            const decodedToken = jwtDecode(token);
            setLogedEmail(decodedToken.email);
        }
    }, []);

    const [formData, setFormData] = useState({
        TransactionID: item.TransactionID,
        InvoiceNr: item.InvoiceNr,
        Date: item.Date,
        PayDate: item.PayDate,
        ActionType: item.ActionType,
        AccountID: item.AccountID,
        Amount18: item.VleraPaTVSH_QirajaBruto,
        Total: item.VleraMeTVSH,
        // VAT18: item.VAT18,
        PaymentOptions: item.PaymentOptions,
        TransactionType: item.TransactionType,
        Comment: item.Comment,
        CompanyUnitID: item.CompanyUnitID,
        // ModifiedByUser: loginEmail
    });

    const [tenants, setTenants] = useState([]);
    const [cashRegister, setCashRegister] = useState([]);

    // Kodi per ruajtjen e te dhenave pas editimint 
    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormData({ ...formData, [name]: value });
        setChangeButton(true);
    };
    //Dergimi i kerkeses per editimin e te dhenave ne backend 
    const handleSubmit = (event) => {
        event.preventDefault();
        axios
            .put(ApiLink.API_URL + 'rent/editOfficialRent', formData, { headers })
            .then((response) => {
                setChangeButton(false);
                updateAlert("Qeraja nga personi juridik u ndryshua me sukses");
            })
            .catch((error) => {
                // alert("Failed to update State");
                errorAlert("Qeraja nga personi juridik nuk u ndryshua")
            });
    };

    useEffect(() => {
        axios.get(ApiLink.API_URL + 'Accounts/paymenttype', { headers, params: { email: logedEmail } })
            .then((response) => {
                setCashRegister(response.data);
            }).catch((error) => {
                // errorAlert(error);
            })
    }, [logedEmail])

    const fetchTenants = async () => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'Accounts/accountByLedger', { headers, params: { ledger: 308 } });
            setTenants(response.data);
        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);
            if (error.response && error.response.data && error.response.data.errorMessage) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
            } else if (error.message) {
                errorAlert(`Gabim: ${error.message}`);
            } else {
                errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
            }
        }
    };

    const calculateNeto = async (brutoValue, type) => {
        try {
            const bruto = Number(brutoValue);
            const tatimiNeQira = bruto * 0.09;
            const qirajaNeto = bruto - tatimiNeQira;
            const vat = bruto * 0.18;
            const totalWithVAT = bruto + vat;
            const payVal = totalWithVAT - tatimiNeQira;

            setNetoRent(qirajaNeto);
            setVat9(tatimiNeQira);
            setPayValue(payVal);
            setVAt(vat);

            if (type !== "start") {
                setFormData(prev => ({
                    ...prev,
                    // VAT18: vat,
                    Total: totalWithVAT
                }));
            }
        } catch (error) {
            errorAlert("Ka ndodhur gabim gjatë kalkulimeve");
        }
    };

    const calculateBruto = async (netoValue) => {
        try {
            const brutoRent = Number(netoValue) / Number(0.91);
            const tatimiNeQira = Number(brutoRent) - Number(netoValue);
            const vat = (Number(brutoRent) * 18) / 100;
            const totalWithVAt = Number(brutoRent) + Number(vat);
            const payVal = Number(totalWithVAt) - Number(tatimiNeQira);

            setChangeButton(true);

            setVat9(tatimiNeQira);
            setPayValue(payVal);
            setVAt(vat);
            setFormData(prev => ({
                ...prev,
                Amount18: brutoRent,
                // VAT18: vat,
                Total: totalWithVAt
            }));

        } catch (error) {
            errorAlert("Ka ndodhur gabim gjatë kalkulimeve");
            // Perform any necessary error handling here
        }
    };


    const calculateFromVleraWithVAT = async (valueWithVAT) => {
        try {
            const brutoRent = (Number(valueWithVAT) * Number(100)) / Number(118);
            const vat9 = (Number(brutoRent) * Number(9)) / Number(100)
            const qirajaNeto = Number(brutoRent) - Number(vat9);
            const vat = Number(valueWithVAT) - Number(brutoRent);
            const payValue = Number(valueWithVAT) - Number(vat9);

            setNetoRent(qirajaNeto);
            setVat9(vat9)
            setPayValue(payValue);
            setVAt(vat);
            setChangeButton(true);

            setFormData(prev => ({
                ...prev,
                Amount18: brutoRent,
                // VAT18: vat,
                Total: valueWithVAT
            }));


        } catch (error) {
            console.error("Error during calculation:", error);
            // Perform any necessary error handling here
        }
    };

    //Select list for tenant
    const handleAutocompleteChangeTenant = (event, value) => {
        if (value) {
            setFormData(prevState => ({
                ...prevState,
                AccountID: value.AccountID
            }));
            setChangeButton(true);
        } else {
            setFormData(prevState => ({
                ...prevState,
                AccountID: ""
            }));
        }
    };

    const defaultPropsTenant = {
        options: tenants,
        getOptionLabel: (option) =>
            `${option.IdentificationNumber} - ${option.AccountName}` || "",
        renderOption: (props, option) => (
            <>
                <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
                    <span>
                        {option.IdentificationNumber}<br />
                        {option.AccountName}
                    </span>
                </li>
            </>
        ),
    };
    ////

    const handleConfirm = () => {
        onClose();
    };

    useEffect(() => {
        // fetchCompaniesData();
        fetchTenants();
    }, [logedEmail, fiscalYear]);

    useEffect(() => {
        calculateNeto(item.VleraPaTVSH_QirajaBruto, "start");
    }, [item.VleraPaTVSH_QirajaBruto]);

    return (
        <div className="Rent__Container">
            <CancelModal
                open={showModal}
                onClose={() => setShowModal(false)}
                title="Konfirmim"
                description="Jeni të sigurt që dëshironi të anuloni ndryshimet?"
                confirmText="po"     // Custom confirm button text
                cancelText="jo"      // Custom cancel button text
                onConfirm={() => handleConfirm()}
            />
            <div className="edit">
                <TitleElements
                    icon={MdEdit}
                    title="Ndyshimi qirasë nga personat juridik "
                />
                <hr></hr>
                <div className="Rent__Container__AllButtons">
                    <div style={{ display: "flex", }}>
                        <InsertTenants fetchData={fetchTenants} type="insert" />
                    </div>
                    <div style={{ display: "flex" }}>
                        {changeButton ? (
                            <>
                                <div style={{ marginLeft: "5px" }}>
                                    <LinkAndClickButton
                                        text="Ruaj"
                                        link="#"
                                        onClick={handleSubmit}
                                    />
                                </div>
                                <div style={{ marginLeft: "5px" }}>
                                    <LinkAndClickButton
                                        text="Anulo"
                                        link="#"
                                        onClick={() => {
                                            setShowModal(true);
                                        }}
                                    />
                                </div>
                            </>
                        ) : (
                            <div style={{ marginLeft: "5px" }}>
                                <LinkAndClickButton
                                    text="Mbyll"
                                    link="#"
                                    onClick={onClose}
                                />
                            </div>
                        )}
                    </div>
                </div>
                {/* <div className='header_paper2'></div> */}
                <HeaderPaperComponent />
                <form className='Rent__Container__Format'>
                    <Paper>
                        <Box
                            component="form"
                            sx={{
                                '& .MuiTextField-root': { m: 1.3, width: '41ch' },
                            }}
                            noValidate
                            autoComplete="off"
                        >
                            <div className='Forma1'>
                                <div className='Boxx'>
                                    {/* <TextField
                                        className="AddPurchaseTotal__Container__Format__SameInput"
                                        // style={{ width: "594px" }}
                                        id="InvoiceNr"
                                        select
                                        name="InvoiceNr"
                                        label="Muaji"
                                        value={formData.InvoiceNr}
                                        onChange={handleInputChange}
                                    >
                                        {Month.map((data) => (
                                            <MenuItem key={data.id} value={fiscalYear + data.month}>{fiscalYear}{data.month}
                                            </MenuItem>
                                        ))}
                                    </TextField> */}

                                    <TextField
                                        className="AddPurchaseTotal__Container__Format__SameInput"
                                        id="InvoiceNr"
                                        label="Numri Faturës"
                                        variant="outlined"
                                        name='InvoiceNr'
                                        value={formData.InvoiceNr}
                                        onChange={handleInputChange}
                                        InputLabelProps={{
                                            shrink: true,
                                        }} />

                                    <div className='AddPurchaseTotal__Container__Format__Dates'>
                                        <TextField
                                            className="AddPurchaseTotal__Container__Format__Date"
                                            id="Date"
                                            type="date"
                                            variant="outlined"
                                            name='Date'
                                            label='Data'
                                            value={formData.Date && formData.Date.substring(0, 10)}
                                            onChange={handleInputChange}
                                            inputProps={{
                                                min: minDate, // Kufizimi minimal i datës
                                                max: maxDate, // Kufizimi maksimal i datës
                                            }}
                                        />

                                        <TextField
                                            className="AddPurchaseTotal__Container__Format__Date"
                                            id="PayDate"
                                            type="date"
                                            variant="outlined"
                                            name='PayDate'
                                            label="Data pagesës"
                                            value={formData.PayDate && formData.PayDate.substring(0, 10)}
                                            onChange={handleInputChange}
                                        />
                                    </div>

                                    <div className="textfield_button">
                                        <Autocomplete
                                            fullWidth
                                            // sx={{ m: 2 }}
                                            {...defaultPropsTenant}
                                            id="AccountID"
                                            includeInputInList
                                            onChange={handleAutocompleteChangeTenant}
                                            renderInput={(params) => (
                                                <TextField {...params}
                                                    label="Qiradhënësi"
                                                    // variant="filled"
                                                    className="AddPurchaseTotal__Container__Format__SameInput"
                                                />
                                            )}
                                            ListboxProps={{
                                                style: {
                                                    maxHeight: '200px', // Caktoni një lartësi maksimale për të lejuar vetëm 4 elemente
                                                    overflow: 'auto',   // Aktivizoni scroll-in për pjesën tjetër
                                                },
                                            }}
                                            value={tenants.find(option => option.AccountID === formData.AccountID) || null}
                                        />
                                    </div>
                                    <div className="AddPurchaseTotal__Container__Format__Dates" style={{ paddingTop: "10px" }}>
                                        <TextField
                                            // style={{ width: "593px" }}
                                            className="AddPurchaseTotal__Container__Format__Date"
                                            id="AccountID"
                                            label="Llogaria Kontabel"
                                            defaultValue=""
                                            value={"308-Qiraja e Pagueshme"}
                                            // onChange={event => setAccountID(703)}
                                            disabled
                                        >
                                        </TextField>

                                        <TextField
                                            // style={{ width: "343px" }}
                                            className="AddPurchaseTotal__Container__Format__Date"
                                            id="id"
                                            select
                                            name="TransactionType"
                                            label="Lloji qirasë"
                                            value={formData.TransactionType}
                                            onChange={handleInputChange}
                                        >
                                            {TranscationData.map((data) => (
                                                <MenuItem key={data.id} value={data.id}>{data.type}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    </div>
                                    <TextField
                                        // style={{ width: "593px" }}
                                        className="AddPurchaseTotal__Container__Format__SameInput"
                                        id="id"
                                        select
                                        label="Mënyra pagesës"
                                        name="PaymentOptions"
                                        value={formData.PaymentOptions}
                                        onChange={handleInputChange}
                                    >
                                        <MenuItem key="0" value="0">Pagesa Behet më vonë
                                        </MenuItem>
                                        {cashRegister.map((data) => (
                                            <MenuItem key={data.AccountID} value={data.AccountID}>{data.AccountName}
                                            </MenuItem>
                                        ))}
                                    </TextField>

                                    <TextareaAutosize
                                        style={{ height: "70px", marginLeft: "10px" }}
                                        className="AddPurchaseTotal__Container__Format__SameInput"
                                        id="Coment"
                                        label="Komenti"
                                        type="text"
                                        name='Coment'
                                        value={formData.Comment}
                                        onChange={handleInputChange}
                                        variant="outlined"
                                        autoComplete="off"
                                    />
                                </div>

                                <div className='box2'>
                                    <TextField
                                        // style={{ width: "150px" }}
                                        className="AddPurchaseTotal__Container__Format__Comment"
                                        id="Amount8"
                                        label="Qiraja Neto"
                                        variant="outlined"
                                        name='Amount8'
                                        value={netoRent !== null && netoRent !== 0 ? netoRent.toLocaleString('en-US', { minimumFractionDigits: 2 }) : '0.00'}
                                        onChange={(e) => setNetoRent(e.target.value)}
                                        onKeyUp={event => calculateBruto(event.target.value)}
                                        InputLabelProps={{
                                            shrink: true,
                                        }} />
                                    <TextField
                                        // style={{ width: "150px" }}
                                        className="AddPurchaseTotal__Container__Format__Comment"
                                        id="outlined-basic"
                                        label="Tatimi në qira 9%"
                                        name='Amount18'
                                        variant="outlined"
                                        value={vat9 !== null && vat9 !== 0 ? vat9.toLocaleString('en-US', { minimumFractionDigits: 2 }) : '0.00'}
                                        // onChange={event => setVat9(event.target.value)}
                                        disabled
                                        // onKeyUp={event => calculateFromTatimi(event.target.value)}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                    <TextField
                                        // style={{ width: "150px" }}
                                        className="AddPurchaseTotal__Container__Format__Comment"
                                        id="Amount18"
                                        label="Qiraja Bruto [Vlera pa TVSH]"
                                        variant="outlined"
                                        name='Amount18'
                                        value={formData.Amount18 !== null && formData.Amount18 !== 0 ? formData.Amount18.toLocaleString('en-US', { minimumFractionDigits: 2 }) : '0.00'}
                                        onChange={handleInputChange}
                                        onKeyUp={event => calculateNeto(event.target.value, "bruto")}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                    <TextField
                                        // style={{ width: "150px" }}
                                        className="AddPurchaseTotal__Container__Format__Comment"
                                        id="VAT"
                                        label="TVSH"
                                        variant="outlined"
                                        name='VAT'
                                        value={vat !== null && vat !== 0 ? vat.toLocaleString('en-US', { minimumFractionDigits: 2 }) : '0.00'}
                                        // onChange={handleInputChange}
                                        disabled
                                        // onKeyUp={event => calculateNeto(event.target.value)}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                    <TextField
                                        // style={{ width: "150px" }}
                                        className="AddPurchaseTotal__Container__Format__Comment"
                                        id="Total"
                                        label="Vlera me TVSH"
                                        variant="outlined"
                                        name='Total'
                                        value={formData.Total !== null && formData.Total !== 0 ? formData.Total.toLocaleString('en-US', { minimumFractionDigits: 2 }) : '0.00'}
                                        onChange={handleInputChange}
                                        onKeyUp={event => calculateFromVleraWithVAT(event.target.value)}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                    <TextField
                                        // style={{ width: "150px" }}
                                        className="AddPurchaseTotal__Container__Format__Comment"
                                        id="PayValue"
                                        label="Vlera per Pagese"
                                        variant="outlined"
                                        name='PayValue'
                                        value={payValue !== null && payValue !== 0 ? payValue.toLocaleString('en-US', { minimumFractionDigits: 2 }) : '0.00'}
                                        // onChange={(e) => setPayValue(e.target.value)}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        disabled
                                    />
                                </div>
                            </div>
                        </Box>
                    </Paper>
                </form>
            </div>
        </div>
    )
}